// extracted by mini-css-extract-plugin
export default {"heading":"ui__heading__ecoQu","subHeading":"ui__subHeading__sZU5K","proTipBox":"ui__proTipBox__Ml4gD"};